import { TRACE_HEADER } from '@calm/web-common/dist/tracing';
import { RumEvent, RumEventDomainContext } from '@datadog/browser-rum-slim';
import { redactActivationTokens } from '@rhg/utils/partner-activation';

export default function beforeSend(
    event: RumEvent,
    context: RumEventDomainContext
) {
    if (
        event.type === 'resource' &&
        event.resource.type === 'xhr' &&
        'response' in context
    ) {
        event.context = {
            ...event.context,
            traceparent:
                context.response?.headers.get(TRACE_HEADER) ??
                'no-tracing-header',
        };
    }
    if (event.view?.url) {
        event.view.url = redactActivationTokens(event.view.url);
    }
    if (event.view?.referrer) {
        event.view.referrer = redactActivationTokens(event.view.referrer);
    }
    return true;
}
